const routes = [
    {
        name: 'listarClientesContabilidade',
        path: '/contabilidade/clientes',
        alias: '/contabilidade/clientes/index',
        component: () => import('../views/Listar'),
    },
    {
        name: 'aceitaConviteContabilidade',
        path: '/contabilidade/clientes/aceitar_convite',
        component: () => import('../views/AceitarConvite'),
    }
]

export default routes
